import Cookies from "js-cookie";
import { decryptValue, stringComparison } from "./app-utils";
export const filterByUserType = (userTypeList: any) => {
    const loggedUserType = decryptValue(Cookies.get("userType") as string);
    const userTypeBusinessAdmin = "BusinessAdmin";
    const userTypeParticipant = "Participant";
  if (loggedUserType != undefined) {
      if (stringComparison(loggedUserType?.toString(), userTypeBusinessAdmin)) {
      let userTypes = userTypeList.filter((r: { value: string }) =>
          stringComparison(r.value, userTypeParticipant) || stringComparison(r.value, userTypeBusinessAdmin)
      );
      return userTypes;
    } else {
      return userTypeList;
    }
  }
};
